import { type HtmlHTMLAttributes } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type CounterBadgeVariant = "default" | "rounded";

type CounterBadgeProps = HtmlHTMLAttributes<HTMLDivElement> & {
  count: number | string;
  variant?: CounterBadgeVariant;
};

export const CounterBadge = ({
  className,
  count,
  variant = "default",
  ...props
}: CounterBadgeProps) => (
  <div
    className={cnTwMerge(
      "text-text/primary flex-0 bg-brand-default text-center font-semibold text-xs",
      variant === "default" && "px-1 min-w-4 rounded-companyBorderRadius",
      variant === "rounded" &&
        "px-2 py-1 min-w-6 min-h-6 rounded-full inline-flex items-center justify-center",
      className,
    )}
    data-testid="counter-badge"
    {...props}
  >
    {count}
  </div>
);
